import { getCurrentInstance } from 'vue';

/**
 * @zh schema
 */
// const templateConfig = {
//     aApp: {
//         videoAction: {
//             follow: false,
//         },
//     },
//     bApp: {
//         videoAction: {
//             follow: false,
//         },
//     },
//     default: {
//         videoAction: {
//             follow: true,
//         },
//     },
// };

export const getTemplateConfig = () => {
    const { $isAppEnvironment } = getCurrentInstance()?.proxy || {};

    return {
        videoAction: {
            follow: !$isAppEnvironment,
            extraActionList: $isAppEnvironment,
        },
    };
};
